module.exports = __webpack_public_path__ + "media/images/imap_accounts/icon_yahoo_japan-62e69c4931ff7370030c708c329dd8b5.png";